import React from 'react';
import AppLayout from '../../layout/app.layout';
import UsersMigration from '../../components/reports/users-migration.component';

const MigrationUsersView = () => {
  const pageTitle = 'Analytics / Migration Users';

  return (
    <AppLayout pageTitle={pageTitle} showFilter>
      <UsersMigration />
    </AppLayout>
  );
};

export default MigrationUsersView;
